import { render, staticRenderFns } from "./HeaderPicker.vue?vue&type=template&id=40ac497c&scoped=true&"
import script from "./HeaderPicker.vue?vue&type=script&lang=js&"
export * from "./HeaderPicker.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPicker.vue?vue&type=style&index=0&id=40ac497c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac497c",
  null
  
)

export default component.exports